import {
  IconTruckContainer,
  IconTruckDryvan,
  IconTruckFlatbed,
  IconTruckLtlDryvan,
  IconTruckReefer,
} from '@loadsmart/icons'

export type Equipment = { name: string; icon: any }

export const TRANSPORTATION_MODES: Record<string, Equipment> = {
  dryvan: { icon: IconTruckDryvan, name: 'DRV' },
  flatbed: { icon: IconTruckFlatbed, name: 'FBE' },
  'intermodal container': { icon: IconTruckContainer, name: 'IMC' },
  'less-than-truckload': { icon: IconTruckLtlDryvan, name: 'LTL' },
  reefer: { icon: IconTruckReefer, name: 'RFR' },
} as const

export type EquipmentType = keyof typeof TRANSPORTATION_MODES

function getInfo(equipmentType: string, info: 'name' | 'icon') {
  const key = equipmentType.toLocaleLowerCase()

  if (!TRANSPORTATION_MODES[key]) {
    throw Error(`Unknown equipment type: ${equipmentType}`)
  }

  return TRANSPORTATION_MODES[key][info]
}

export const getTruckIcon = (equipmentType: string) =>
  getInfo(equipmentType, 'icon')
export const getTruckName = (equipmentType: string) =>
  getInfo(equipmentType, 'name')
